import "./index.scss";
import Image from "next/image";

export default function Menu() {
    return (
        <>
          {/* Menu Section */}

      <section id="menu" className="catering-menu-wrapper py-20">
        <article className="pink-area mb-20">
          <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center text-red-900 uppercase">
            MENU
          </h2>
          <div className="w-16 h-1 bg-red-900 mx-auto mb-12 mt-2">
          </div>
            <div className="flex flex-wrap items-center justify-center relative">
              <div className="text-area-width">
                <div className="cat-left-img bg-red flex text-white">
                  <Image
                    width={200}
                    height={100}
                    src="/shared/NORTH INDIAN 2.png"
                    alt="NORTH INDIAN 2"
                  />
                  <div className="catering-menu_decs">
                    <h2 className="catering-menu_heading text-[28px] font-bold mb-2">
                      NORTH INDIAN
                    </h2>
                    <p className="mb-5">
                      Indian cuisine is every bit as unique as the country and
                      its people. Each region of India has its style of cooking
                      and distinct flavors. The North region is known for its
                      tandoori and korma dishes. Each dish is a statement of
                      culinary excellence - something all our chefs take pride
                      in.
                    </p>
                    <a
                      href="https://tabla-static.s3.us-east-2.amazonaws.com/NORTH+INDIAN-min+1.pdf"
                      target="_blank"
                      className="catering-menu_start-button bg-white rounded py-2 px-3 text-red-900"
                    >
                      View menu
                    </a>
                  </div>
                </div>
              </div>
              <div className="image-area-width">
                <div className="cat-right-onlyimg">
                  <Image
                    width={400}
                    height={370}
                    src="/shared/NORTH INDIAN.png"
                    alt="NORTH INDIAN"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        <article className="green-area mb-20">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex flex-wrap items-center justify-center relative">
              <div className="image-area-width">
                <div className="cat-left-onlyimg">
                  <Image
                    width={400}
                    height={370}
                    src="/shared/SOUTH INDIAN.png"
                    alt="SOUTH INDIAN"
                  />
                </div>
              </div>
              <div className="text-area-width">
                <div className="cat-right-img bg-red flex text-white">
                  <div className="catering-menu_decs">
                    <h2 className="catering-menu_heading text-[28px] font-bold mb-2">
                      SOUTH INDIAN
                    </h2>
                    <p className="mb-5">
                      South Indian cuisine usually consists of dishes from the
                      five southern states of India: Andhra Pradesh, Karnataka,
                      Kerala, Tamil Nadu, and Telangana. This cuisine is famous
                      for its various spices, spicy foods, and the significant
                      use of coconut in its dishes. This includes dishes such as
                      Dosa, Idli, Vadas, and Uttapams and is usually served with
                      Sambar.
                    </p>
                    <a
                      href="https://tabla-static.s3.us-east-2.amazonaws.com/SOUTH+INDIAN-min.pdf"
                      target="_blank"
                      className="catering-menu_start-button bg-white rounded py-2 px-3 text-red-900"
                    >
                      View menu
                    </a>
                  </div>
                  <Image
                    width={200}
                    height={100}
                    src="/shared/SOUTH INDIAN 2.png"
                    alt="SOUTH INDIAN 2"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        <article className="pink-area mb-20">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex flex-wrap items-center justify-center relative">
              <div className="text-area-width">
                <div className="cat-left-img bg-red flex text-white">
                  <Image
                    width={200}
                    height={100}
                    src="/shared/GUJARATI 2.png"
                    alt="GUJARATI 2"
                  />
                  <div className="catering-menu_decs">
                    <h2 className="catering-menu_heading text-[28px] font-bold mb-2">
                      GUJARATI
                    </h2>
                    <p className="mb-5">
                      Gujarati Cuisine usually refers to the cuisine of Gujarat,
                      a state in Western India. Gujarati cuisine is primarily
                      vegetarian, so its dishes emphasize its spices and rich
                      flavors. A traditional, authentic Gujarati offering
                      consists of Daal, Bhat (boiled rice), Shak, Rotli/Puri’s,
                      and a small sweet dish. When it comes to desserts, Keri no
                      ras, Shrikhand, Gajar halwa, and Gulab jamun are amongst
                      some of the favorites.
                    </p>
                    <a
                      href="https://tabla-static.s3.us-east-2.amazonaws.com/Gujarati-min.pdf"
                      target="_blank"
                      className="catering-menu_start-button bg-white rounded py-2 px-3 text-red-900"
                    >
                      View menu
                    </a>
                  </div>
                </div>
              </div>
              <div className="image-area-width">
                <div className="cat-right-onlyimg">
                  <Image
                    width={400}
                    height={370}
                    src="/shared/GUJARATI.png"
                    alt="GUJARATI"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        <article className="green-area mb-20">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex flex-wrap items-center justify-center relative">
              <div className="image-area-width">
                <div className="cat-left-onlyimg">
                  <Image
                    width={400}
                    height={370}
                    src="/shared/INDO CHINESE.png"
                    alt="INDO CHINESE"
                  />
                </div>
              </div>
              <div className="text-area-width">
                <div className="cat-right-img bg-red flex text-white">
                  <div className="catering-menu_decs">
                    <h2 className="catering-menu_heading text-[28px] font-bold mb-2">
                      INDO CHINESE
                    </h2>
                    <p className="mb-5">
                      Indo-Chinese cuisine is a delicious mix of flavors with
                      the adaptation of Chinese seasoning and cooking techniques
                      to Indian tastes. This food is flavored with various
                      spices also used in Indian Cuisines alongside sesame
                      seeds, black pepper, and yogurt, which makes this food
                      taste similar to many ethnic dishes in Southeast Asian
                      countries.
                    </p>
                    <a
                      href="https://tabla-static.s3.us-east-2.amazonaws.com/Indo-Chinese-min.pdf"
                      target="_blank"
                      className="catering-menu_start-button bg-white rounded py-2 px-3 text-red-900"
                    >
                      View menu
                    </a>
                  </div>
                  <Image
                    width={200}
                    height={100}
                    src="/shared/INDO CHINESE 2.png"
                    alt="INDO CHINESE 2"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>

        <article className="pink-area">
          <div className="max-w-6xl mx-auto px-6">
            <div className="flex flex-wrap items-center justify-center relative">
              <div className="text-area-width">
                <div className="cat-left-img bg-red flex text-white">
                  <Image
                    width={200}
                    height={100}
                    src="/shared/INTERNATIONAL FUSION 2.png"
                    alt="INTERNATIONAL FUSION 2"
                  />
                  <div className="catering-menu_decs">
                    <h2 className="catering-menu_heading text-[28px] font-bold mb-2">
                      INTERNATIONAL FUSION
                    </h2>
                    <p className="mb-5">
                      International Fusion cuisine is known for its distinct
                      flavors with a wide variety of ingredients. It is also
                      known for its colorful and deep intense flavors. Modern
                      Asian fusion cuisine incorporates ingredients that are
                      more traditionally found in Asian dishes and blends them
                      with other style dishes.
                    </p>
                    <a
                      href="https://tabla-static.s3.us-east-2.amazonaws.com/INTERNATIONAL+FUSION-min.pdf"
                      target="_blank"
                      className="catering-menu_start-button bg-white rounded py-2 px-3 text-red-900"
                    >
                      View menu
                    </a>
                  </div>
                </div>
              </div>
              <div className="image-area-width">
                <div className="cat-right-onlyimg">
                  <Image
                    width={400}
                    height={370}
                    src="/shared/INTERNATIONAL FUSION.png"
                    alt="INTERNATIONAL FUSION"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
        </>
    )
}